var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var Mssg = dynamicRequire('Mssg.jsx');

class ExteriorMeasures extends React.Component {

    render() {
        return <p className="lr-casefactory-choices-exterior exterior">
            <Mssg __key="nc_casefactory.exterior.dimensions" />:<br />
            <span>{asCm(this.props.case.dimensions.exterior.width)}</span>{' '}<Mssg __key="nc_casefactory.centimeter" />{' '}x{' '}
            <span>{asCm(this.props.case.dimensions.exterior.height)}</span>{' '}<Mssg __key="nc_casefactory.centimeter" />{' '}x{' '}
            <span>{asCm(this.props.case.dimensions.exterior.depth)}</span>{' '}<Mssg __key="nc_casefactory.centimeter" />
        </p>
    }
}

function asCm(mm) {
    return (mm / 10).toLocaleString();
}

ExteriorMeasures.contextTypes = {
};

module.exports = ExteriorMeasures;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Dimensions/ExteriorMeasures.jsx